import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, RowStyle } from 'ag-grid-community';
import { SqpGridColDefs } from '../models/sqp-grid-col-defs';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';

@Component({
  selector: 'app-sqp-grid-component',
  templateUrl: './sqp-grid-component.component.html',
  styleUrls: ['./sqp-grid-component.component.css']
})
export class SqpGridComponentComponent implements OnInit {

  api: any;
  apiCol: any;
  @Input() columnDefs: ColDef[];
  sqpColumnDefs: ColDef[] = [];
  @Input() data: any[];
  @Input() iconoEditar: boolean = false;
  rowStyle: RowStyle;
  @Input() seleccion: string;
  overlayNoRowsTemplate: string ='<span>No se han encontrado datos</span>';
  overlayLoadingTemplate: string ='<span class="ag-overlay-loading-center">Cargando...</span>';
  @Input() deseleccionar: {count:number, uncheck: boolean};
  @ViewChild('agGrid', { static: false }) agGrid: AgGridAngular;
  @Output() refresh:EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() seleccionEliminarEmitter: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() abrirModalDataEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Input() gridOptions:any;
  @Input() tipoData: string;
  @Output() onScrollEnd:EventEmitter<void> = new EventEmitter<void>();
  @Output() ordenColumnaEmitter: EventEmitter<OrdenColumna> = new EventEmitter<OrdenColumna>();
  @Output() headerSelectionToggled: EventEmitter<boolean> = new EventEmitter<boolean>();
  private firstLoad = true;
  @Input() suppressSelectionEvents: boolean = false;

  constructor() { }

  //BORRAR NGONCHANGES AL FINAL DE IMPLEMENTAR SCROLL INFINITO EN TODAS LAS PARTES
  ngOnChanges(changes: SimpleChanges){
    if(changes && changes.deseleccionar?.currentValue?.count>0){
      if (this.agGrid && this.agGrid.api) {
        this.suppressSelectionEvents = true;
        this.agGrid.api.deselectAll();
        queueMicrotask(() => this.suppressSelectionEvents = false); // Es similar a Promise.resolve().then(() => ...), pero se ejecuta antes que setTimeout(0) (que es una macrotarea y se aplaza para más tarde, posiblemente después del repintado).
      }
    }
  }

  ngOnInit(): void {
    this.seleccion=='single'? this.rowStyle = { cursor: 'pointer' }:'';
    this.cargarColumnas();
  }

  cargaApi(arg: any){
    this.api = arg.api;
    this.apiCol = arg.columnApi;
    if(this.tipoData=='firmas'){
      this.api.applyColumnState({
        // state: [{ colId: 'fechaFirma', sort: 'desc' }],
        defaultState: { sort: null },
      });
    }else this.api.sizeColumnsToFit();

  }

  onCellClicked(event: any){
    if(this.iconoEditar){
      const lastColumnIndex = this.sqpColumnDefs.length - 1;
      if (event.column.colDef.field === this.sqpColumnDefs[lastColumnIndex].field) {
        this.abrirModalDataEmitter.emit(event);
      }
    }else{
      this.abrirModalDataEmitter.emit(event);
    }
  }

  onSelectionChanged(event:any){
    if (this.suppressSelectionEvents) return;
    const rowsSeleccionadasEliminar = this.api.getSelectedRows();
    if (event?.source === 'uiSelectAll') { //Miramos si se ha clicado el headercheckbox
      const allSelected = rowsSeleccionadasEliminar.length > 0;
      this.headerSelectionToggled.emit(allSelected);

      // If it's a "select all" action, immediately deselect all rows to prevent blue painting
      if (allSelected) {
        // Set suppress flag immediately to prevent any further selection events
        this.suppressSelectionEvents = true;
        // Deselect all rows immediately
        this.api.deselectAll();
        // Reset the flag after a microtask
        queueMicrotask(() => {
          this.suppressSelectionEvents = false;
        });
      }

      // Don't emit seleccionEliminarEmitter for header checkbox actions
      return;
    }
    this.seleccionEliminarEmitter.emit(rowsSeleccionadasEliminar);
  }

  cargarColumnas(){
    this.sqpColumnDefs = [];
    const sqpGridColDefs = new SqpGridColDefs().sqpColumnDefs;
    const columnDefsToReverse = [...this.columnDefs];
    if(!this.iconoEditar) this.columnDefs.forEach(x=> this.sqpColumnDefs.push(x))
    else {

      columnDefsToReverse.reverse().forEach(x=> sqpGridColDefs.unshift(x));
      this.sqpColumnDefs = [...sqpGridColDefs];
    }
  }

  onScroll(event:any){
    if (this.firstLoad) {
      this.firstLoad = false; // Prevents emitting on first load
      return;
    }
    // Get vertical pixel range
    const verticalRange = event.api.getVerticalPixelRange(); // The visible range of the grid
    const totalRows = event.api.getDisplayedRowCount(); // Total number of rows

    let totalScrollHeight = 0;

    // Calculate the total scrollable height by summing each row's height
    for (let i = 0; i < totalRows; i++) {
      const rowNode = event.api.getDisplayedRowAtIndex(i);
      if (rowNode?.rowHeight) {
        totalScrollHeight += rowNode.rowHeight;
      }
    }

    // Bottom position of the last row
    const lastRowNode = event.api.getDisplayedRowAtIndex(totalRows - 1);
    const lastRowBottomPosition = totalScrollHeight;

    // Trigger event only when close to the bottom
    if (verticalRange.bottom + 10 >= lastRowBottomPosition) {
      // this.scrollSubject.next();
      this.onScrollEnd.emit()
    }
  }

  onSortChanged(event: any) {
    // Get all columns that have sorting applied
    const sortedColumns = event.api.getColumnState().filter(col => col.sort);

    if (sortedColumns.length > 0) {
      // Get the last sorted column (most recent sort action)
      const lastSortedColumn = sortedColumns[sortedColumns.length - 1];
      this.ordenColumnaEmitter.emit({campoOrden: lastSortedColumn.colId, orden: lastSortedColumn.sort})
    }else this.ordenColumnaEmitter.emit({campoOrden: '', orden: ''});
  }

}
